"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.watchPageMount = watchPageMount;
exports.watchGetTokenRequest = watchGetTokenRequest;
exports.watchRefreshToken = watchRefreshToken;
exports.exchangeToken = exchangeToken;
exports.watchTokenResponse = watchTokenResponse;
exports.setAgentToken = setAgentToken;

var _effects = require("redux-saga/effects");

var _actions = require("../actions");

var _agentTokenService = require("../services/agentTokenService");

var _appSelector = require("../selectors/appSelector.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(watchPageMount),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getTokenRequest),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(watchGetTokenRequest),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchRefreshToken),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(exchangeToken),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(watchTokenResponse),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(setAgentToken);

function watchPageMount() {
  return regeneratorRuntime.wrap(function watchPageMount$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!true) {
            _context.next = 5;
            break;
          }

          _context.next = 3;
          return (0, _effects.takeLatest)('PAGE_MOUNTED', getTokenRequest);

        case 3:
          _context.next = 0;
          break;

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function getTokenRequest(_ref) {
  var payload, pageTitle, config, auth, agentTokenPageTitle;
  return regeneratorRuntime.wrap(function getTokenRequest$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref.payload;
          pageTitle = payload.pageTitle;
          _context2.next = 4;
          return (0, _effects.select)(_appSelector.configSelector);

        case 4:
          config = _context2.sent;
          _context2.next = 7;
          return (0, _effects.select)(_appSelector.authenticationSelector);

        case 7:
          auth = _context2.sent;

          if (config) {
            _context2.next = 10;
            break;
          }

          return _context2.abrupt("return");

        case 10:
          agentTokenPageTitle = config.pageTitle;

          if (!(pageTitle === agentTokenPageTitle && !(auth !== null && auth !== void 0 && auth.agentTokenDetails))) {
            _context2.next = 14;
            break;
          }

          _context2.next = 14;
          return (0, _effects.put)({
            type: _actions.GET_TOKEN_REQUEST
          });

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function watchGetTokenRequest() {
  return regeneratorRuntime.wrap(function watchGetTokenRequest$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeLatest)(_actions.GET_TOKEN_REQUEST, exchangeToken);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function watchRefreshToken() {
  return regeneratorRuntime.wrap(function watchRefreshToken$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.takeEvery)(_actions.REFRESH_TOKEN, exchangeToken);

        case 3:
          _context4.next = 8;
          break;

        case 5:
          _context4.prev = 5;
          _context4.t0 = _context4["catch"](0);
          console.error('Unable to call get agent token, error: ', _context4.t0);

        case 8:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[0, 5]]);
}

function exchangeToken(data) {
  var _data$payload;

  var isRefreshTokenFlow, azureToken, getAgentTokenParams, agentTokenResponse, storageTokenType;
  return regeneratorRuntime.wrap(function exchangeToken$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          isRefreshTokenFlow = data === null || data === void 0 ? void 0 : (_data$payload = data.payload) === null || _data$payload === void 0 ? void 0 : _data$payload.access_token;

          if (isRefreshTokenFlow) {
            _context5.next = 6;
            break;
          }

          _context5.next = 4;
          return (0, _effects.put)({
            type: _actions.GLOBAL_LOADING,
            payload: true
          });

        case 4:
          _context5.next = 7;
          break;

        case 6:
          null;

        case 7:
          _context5.next = 9;
          return (0, _effects.select)(_appSelector.azureTokenSelector);

        case 9:
          azureToken = _context5.sent;
          _context5.prev = 10;
          getAgentTokenParams = {
            token: azureToken
          };

          if (!isRefreshTokenFlow) {
            _context5.next = 15;
            break;
          }

          _context5.next = 15;
          return (0, _effects.put)((0, _actions.refreshTokenFlow)(true));

        case 15:
          _context5.next = 17;
          return (0, _effects.call)(_agentTokenService.getAgentToken, getAgentTokenParams);

        case 17:
          agentTokenResponse = _context5.sent;
          _context5.next = 20;
          return (0, _effects.select)(_appSelector.storeToken);

        case 20:
          storageTokenType = _context5.sent;

          if (storageTokenType === 'cookies') {
            delete agentTokenResponse.access_token;
            delete agentTokenResponse.refresh_token;
          }

          _context5.next = 24;
          return (0, _effects.put)((0, _actions.setAgentResponse)(agentTokenResponse));

        case 24:
          if (isRefreshTokenFlow) {
            _context5.next = 27;
            break;
          }

          _context5.next = 27;
          return (0, _effects.put)({
            type: _actions.GLOBAL_LOADING,
            payload: false
          });

        case 27:
          _context5.next = 42;
          break;

        case 29:
          _context5.prev = 29;
          _context5.t0 = _context5["catch"](10);

          if (isRefreshTokenFlow) {
            _context5.next = 40;
            break;
          }

          _context5.next = 34;
          return (0, _effects.put)((0, _actions.setAgentResponseFailure)(_context5.t0));

        case 34:
          _context5.next = 36;
          return (0, _effects.put)((0, _actions.setError)((_context5.t0 === null || _context5.t0 === void 0 ? void 0 : _context5.t0.status) || 500, {
            type: _actions.GET_TOKEN_REQUEST
          }));

        case 36:
          _context5.next = 38;
          return (0, _effects.put)({
            type: _actions.GLOBAL_LOADING,
            payload: false
          });

        case 38:
          _context5.next = 42;
          break;

        case 40:
          _context5.next = 42;
          return (0, _effects.put)({
            type: _actions.LOGOUT_HANDLER
          });

        case 42:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[10, 29]]);
}

function watchTokenResponse() {
  return regeneratorRuntime.wrap(function watchTokenResponse$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.takeEvery)(_actions.GET_TOKEN_SUCCESS, setAgentToken);

        case 3:
          _context6.next = 8;
          break;

        case 5:
          _context6.prev = 5;
          _context6.t0 = _context6["catch"](0);
          console.error(_context6.t0);

        case 8:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[0, 5]]);
}

function setAgentToken(_ref2) {
  var payload, authentication;
  return regeneratorRuntime.wrap(function setAgentToken$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _ref2.payload;
          _context7.next = 3;
          return (0, _effects.select)(_appSelector.authenticationSelector);

        case 3:
          authentication = _context7.sent;
          _context7.next = 6;
          return (0, _effects.put)((0, _actions.loggedIn)(_objectSpread(_objectSpread({}, authentication), {}, {
            agentTokenDetails: payload
          })));

        case 6:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}